export default "__VITE_ASSET__BW6P0DGG__"